import useResponsive from '@creditflowresearch/uilib/hooks/useResponsive';
import { HeaderLayoutDesktop } from '@/creditflowresearch/ui/common/components/templates/HeaderLayout';
import { HeaderLayoutMobile } from '@/creditflowresearch/ui/common/components/templates/HeaderLayout';
// Temporary wrapper for search functionality - remove when SearchWrapper is removed
import HeaderMenuContextProvider from '@/creditflowresearch/application/SearchHeaderMenu/HeaderMenuContext';
import HeaderContextProvider from '@/creditflowresearch/application/Header/HeaderContext';

interface IHeaderProps {
  logo?: React.ReactNode,
  searchComponent?: React.ReactNode,
  userActionButtons?: React.ReactNode,
  menuActionButtons?: React.ReactNode,
  links?: React.ReactNode,
}

const Header = (props: IHeaderProps) => {
  const isMobile = useResponsive(({ width }) => width < 1024);

  // Temporary wrapper for search functionality - remove when SearchWrapper is removed
  return (
    <HeaderContextProvider>
      <HeaderMenuContextProvider>
        { isMobile ? <HeaderLayoutMobile { ...props } /> : <HeaderLayoutDesktop { ...props } /> }
      </HeaderMenuContextProvider>
    </HeaderContextProvider>
  );
};

export default Header;
